import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Home, AlertCircle } from 'lucide-react';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '60vh',
      textAlign: 'center',
      padding: '2rem'
    }}>
      <div style={{
        backgroundColor: 'rgba(255, 107, 107, 0.1)',
        padding: '2rem',
        borderRadius: '50%',
        marginBottom: '2rem'
      }}>
        <AlertCircle size={80} color="var(--danger-color)" />
      </div>
      
      <h1 style={{ fontSize: '3rem', marginBottom: '1rem', color: 'var(--primary-color)' }}>
        404
      </h1>
      
      <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem' }}>
        Oups ! Cette page s'est perdue.
      </h2>
      
      <p style={{ color: 'var(--text-secondary)', marginBottom: '2.5rem', maxWidth: '400px' }}>
        Il semblerait que tu aies soulevé trop lourd et atterri dans une zone inconnue. L'URL que tu cherches n'existe pas ou a été déplacée.
      </p>
      
      <button 
        className="btn btn-primary" 
        style={{ display: 'flex', alignItems: 'center', gap: '0.8rem', padding: '0.8rem 2rem', fontSize: '1.1rem' }}
        onClick={() => navigate('/')}
      >
        <Home size={20} />
        Retour à l'accueil
      </button>
    </div>
  );
};

export default NotFound;
